import React from 'react'
import { IMenu, Menu } from './menu';
import { Logo } from './logo';
import './navigator.css';
import './menuitem.css';
import { IState } from '../chatbot/api/llmapi';
import UserMenu from './usermenu';
import { FaBars, FaTimes } from 'react-icons/fa';

interface Props {
    children : IMenu[];
    state    : IState;
}

interface State {
    mobileMenuOpen : boolean;
}

export class Navigator extends React.Component<Props, State> {

    private closeMenuSubmenus : (() => void) | null = null;
    private closeUserDropdown : (() => void) | null = null;

    constructor(props : Props) {
        super(props);
        this.state = {
            mobileMenuOpen : false
        };
    }

    toggleMobileMenu() {
        this.setState(prev => {
            if (prev.mobileMenuOpen) {
                this.closeMenuSubmenus?.();
                this.closeUserDropdown?.();
            }
            return { mobileMenuOpen : !prev.mobileMenuOpen };
        });
    }

    render() {
        const { mobileMenuOpen } = this.state;
        return (
            <nav className={`nav${mobileMenuOpen ? ' nav-open' : ''}`}>
                <div className="nav-header">
                    <button className="nav-toggle" onClick={() => this.toggleMobileMenu()}>
                        {React.createElement((mobileMenuOpen ? FaTimes : FaBars) as React.ComponentType)}
                    </button>
                    <a className="logo-container" href="/">
                        <Logo/>
                    </a>
                </div>
                <div className="nav-body">
                    <Menu children={ this.props.children } closeMenu={() => this.setState({ mobileMenuOpen : false })}
                        onRegisterCloseSubmenus={fn => this.closeMenuSubmenus = fn}
                        onBeforeOpen={() => this.closeUserDropdown?.()} />
                    <UserMenu state={ this.props.state }
                        onRegisterCloseDropdown={fn => this.closeUserDropdown = fn}
                        onBeforeOpen={() => this.closeMenuSubmenus?.()} />
                </div>
            </nav>
        );
    }
}
